import React from 'react'
import { TextField as MuiTextField } from '@material-ui/core'

/**
 * Wrapper around TextField with common props set
 * https://v4.mui.com/api/text-field/
 */
const TextField = (props) => {
  return (
    <MuiTextField
      margin='dense'
      variant='outlined'
      fullWidth
      InputLabelProps={{ shrink: true }}
      InputProps={{ inputProps: { autoCapitalize: 'off', autoComplete: 'off', autoCorrect: 'off', spellCheck: 'false' } }}
      {...props}
    >
      {props.children}
    </MuiTextField>
  )
}

export default TextField
